import { FC, PropsWithChildren, createContext, useContext, useMemo, useState } from 'react';

export interface SnackbarContent {
  message: string;
  severity: 'error' | 'warning' | 'info' | 'success';
}

interface ContextState {
  snackbar?: SnackbarContent;
  openSnackbar: (snackbarContent: SnackbarContent) => void;
  closeSnackbar: () => void;
}

const SnackbarContext = createContext<ContextState>({} as ContextState);

export const SnackbarContextProvider: FC<PropsWithChildren> = ({ children }) => {
  const [snackbar, setSnackbar] = useState<SnackbarContent | undefined>(undefined);

  const openSnackbar = (snackbarContent: SnackbarContent) => setSnackbar(snackbarContent);
  const closeSnackbar = () => setSnackbar(undefined);

  const values = useMemo(
    () => ({
      snackbar,
      openSnackbar,
      closeSnackbar,
    }),
    [snackbar],
  );

  return <SnackbarContext.Provider value={values}>{children}</SnackbarContext.Provider>;
};

export const useSnackbarContext = (): ContextState => useContext(SnackbarContext);
